import { useContext } from 'react'

import { ParticipantsContext } from '.'

export default function useParticipantsContext() {
    const context = useContext(ParticipantsContext)
    if (!context)
        throw new Error(
            'useParticipantsContext must be used within a ParticipantsContextProvider'
        )

    return context
}
